/** Identificações do Cliente */
export interface ConfigEmpresaIdentificacaoCliente {
    id: number;
    nome: string;
}

export const identificacoClienteNome: ConfigEmpresaIdentificacaoCliente = {id: 1, nome: 'Nome'};
export const identificacoClienteNomeFantasia: ConfigEmpresaIdentificacaoCliente = {id: 2, nome: 'Fantasia'};

export const identificacoesCliente: ConfigEmpresaIdentificacaoCliente[] = [
    identificacoClienteNome,
    identificacoClienteNomeFantasia
];

/** Verifica se a identificação do Cliente é por Nome */
export function isIdentificacaoClienteNome(identificacao: number): boolean {
    if (!identificacao) {
        return false;
    }
    return identificacao === identificacoClienteNome.id;
}

/** Verifica se a identificação do Cliente é por Nome Fantasia */
export function isIdentificacaoClienteNomeFantasia(identificacao: number): boolean {
    if (!identificacao) {
        return false;
    }
    return identificacao === identificacoClienteNomeFantasia.id;
}

/** Retorna o nome primário do cliente conforme a identificação do cliente pela empresa selecionada na configuração da Empresa */
export function createNomeCliente(identificacao: number, nome: string, nomeFantasia: string): string {
    // Nome Fantasia
    if (isIdentificacaoClienteNomeFantasia(identificacao) && nomeFantasia && nomeFantasia.trim().length > 0) {
        return nomeFantasia ?? '';
    }

    // Padrão Nome
    return nome ?? '';
}

/** Retorna o nome secundário do cliente conforme a identificação do cliente pela empresa selecionada na configuração da Empresa */
export function createNomeSecundarioCliente(identificacao: number, nome: string, nomeFantasia: string, codigoIntegracaoErp: string = null): string {
    let codigo = '';
    if (codigoIntegracaoErp) {
        codigo = `${codigoIntegracaoErp} - `;
    }

    // Nome Fantasia retorna o nome
    if (isIdentificacaoClienteNomeFantasia(identificacao)) {
        return `${codigo}${nome ?? ''}`;
    }

    // Nome retorna o nome fantasia
    return `${codigo}${nomeFantasia ?? ''}`;
}
